import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import { vocabularize } from "src/Common/vocab";
import { useState, forwardRef, useEffect } from "react";
import { WO_TYPE_LIST } from "src/Common/contants";
import ServiceTypeDropdown from "./dropdown/ServiceTypeDropdown";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DatePickerModal from "src/Common/datepickermodal";
import DateInput from "src/Components/Input/dateinput";
import UserDropDown from "./AssignTech/userdropdown";
import UserService from "src/Services/API/user.service";
import { handleError } from "src/Common/function";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

function ApproveModal({
  shown,
  onCancelClicked,
  onApproveClicked,
  defaultServiceType = null,
  lockServiceType = false,
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const branch = Number(searchParams.get("branch"));

  // const [type, setType] = useState(0);
  const [serviceType, setServiceType] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [primaryTech, setPrimaryTech] = useState(null);
  const [technicians, setTechnicians] = useState([]);
  const [isUserDropDownOpen, setIsUserDropDownOpen] = useState(false);
  // Optional: sent to the customer in the work order's chat on approval.
  const [etaMessage, setEtaMessage] = useState("");
  const [etaInfoShown, setEtaInfoShown] = useState(false);

  const StartInput = forwardRef(({ value, onClick }, ref) => <DateInput text={value} onClick={onClick} />);

  const primaryTechSelected = (i) => {
    if (i == -1) {
      setIsUserDropDownOpen(false);
    } else if (i == -2) {
      setIsUserDropDownOpen(true);
    } else {
      setPrimaryTech(technicians[i]);
      setIsUserDropDownOpen(false);
    }
  };

  // const typeSelected = (index) => {
  //   setType(index);
  // };

  useEffect(() => {
    getTechnicians();
  }, [branch]);

  // Reset every input whenever the modal is re-opened so a previous
  // (cancelled) approval attempt doesn't leak into the next one. Type of
  // Service starts at what the customer asked for (service or a quote).
  useEffect(() => {
    setServiceType(defaultServiceType);
    setStartDate(null);
    setPrimaryTech(null);
    setIsUserDropDownOpen(false);
    setEtaMessage("");
    setEtaInfoShown(false);
  }, [shown]);

  const getTechnicians = async () => {
    // Roles are dynamic (managed in IAM), so the picker lists all enabled
    // users instead of hardcoding role names.
    UserService.getUsersForAssign(null, branch)
      .then((response) => {
        if (response.status == 200) {
          setTechnicians(
            response.data.filter((user) => user.isEnabled === true).sort((a, b) => a.name.localeCompare(b.name)),
          );
        }
      })
      .catch((error) => handleError(error));
  };

  const approveClicked = () => {
    // The WO number is auto-assigned by the backend from the branch prefix
    // at approval time, so nothing to validate here.
    onApproveClicked(serviceType, startDate, primaryTech, etaMessage.trim());
  };

  return (
    shown && (
      <div className="fixed top-0 left-0 right-0 bottom-0 w-screen h-screen  flex items-center justify-center z-30 bg-black/50">
        <OutsideClickHandler onOutsideClick={onCancelClicked}>
          <div className="w-[440px] px-5 py-5 bg-white p-[18px] flex flex-col  rounded-[6px] shadow-2xs relative">
            <p className="text-[16px] font-OpenSansMedium font-[600] text-titleColor mb-5 text-center">
              {vocabularize("APPROVE WORK ORDER")}
            </p>
            <p className="text-[11px] font-OpenSansRegular text-subTitleColor mb-2">
              The work order # will be assigned automatically on approval. Start date, technician and
              ETA can be left empty and set later.
            </p>

            <div className="h-[60px] w-full mb-2">
              <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-1">Type of Service</p>
              {/* A customer's quote request is a Quoted Job already; nothing to pick. */}
              {lockServiceType && defaultServiceType ? (
                <p className="h-[30px] flex items-center text-[13px] font-OpenSansRegular text-titleColor">
                  {defaultServiceType.serviceType}
                </p>
              ) : (
                <ServiceTypeDropdown selectedItem={serviceType} onSelect={setServiceType} />
              )}
            </div>

            <div className="h-[60px] w-full mb-2">
              <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-1">
                Start Date <span className="font-OpenSansRegular font-[400] text-subTitleColor">(optional)</span>
              </p>

              <DatePicker
                selected={startDate}
                onChange={(date) => {
                  setStartDate(date);
                }}
                customInput={<StartInput />}
              />
            </div>

            <div className="w-full mb-2">
              <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-1">
                Assign Primary Technician <span className="font-OpenSansRegular font-[400] text-subTitleColor">(optional)</span>
              </p>
              <UserDropDown
                options={technicians}
                selectedUser={primaryTech}
                onSelect={primaryTechSelected}
                isOpen={isUserDropDownOpen}
              />
            </div>

            <div className="w-full mb-2">
              <div className="flex items-center gap-1 mb-1">
                <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor">
                  ETA Message <span className="font-OpenSansRegular font-[400] text-subTitleColor">(optional)</span>
                </p>
                {/* Shows its explanation on hover (and on keyboard focus). */}
                <span
                  className="relative"
                  onMouseEnter={() => setEtaInfoShown(true)}
                  onMouseLeave={() => setEtaInfoShown(false)}
                >
                  <button
                    type="button"
                    aria-label="About the ETA message"
                    aria-describedby="eta-message-info"
                    onFocus={() => setEtaInfoShown(true)}
                    onBlur={() => setEtaInfoShown(false)}
                    className="w-[14px] h-[14px] rounded-full border border-subTitleColor text-subTitleColor text-[9px] leading-none font-OpenSansBold flex items-center justify-center cursor-help hover:border-blueColor hover:text-blueColor"
                  >
                    i
                  </button>
                  {etaInfoShown && (
                    <span
                      id="eta-message-info"
                      role="tooltip"
                      className="absolute left-1/2 -translate-x-1/2 bottom-[calc(100%+6px)] w-[260px] px-3 py-2 rounded-[6px] bg-titleColor text-white text-[11px] leading-[16px] font-OpenSansRegular shadow-lg z-10 pointer-events-none"
                    >
                      Optional. When you approve, this is sent to the customer as a message in the work order's
                      Customer Chat, so they know when to expect you. They get it like any other message from
                      the office (email or push, per their settings).
                    </span>
                  )}
                </span>
              </div>
              <textarea
                value={etaMessage}
                onChange={(event) => setEtaMessage(event.target.value)}
                rows={3}
                placeholder="e.g. A technician will be there Thursday between 8 and 10 AM."
                className="w-full px-3 py-2 rounded-[5px] border border-borderColor text-[12px] font-OpenSansRegular text-titleColor resize-none focus:outline-none focus:border-blueColor"
              />
            </div>

            <div className="flex items-center justify-between gap-3 mt-3">
              <div
                onClick={onCancelClicked}
                className="w-[50%] h-[30px] text-[10px] rounded-[6px] border-[1px] border-subTitleColor flex items-center justify-center text-subTitleColor cursor-pointer"
              >
                CANCEL
              </div>
              <div
                data-testid="approve-submit"
                onClick={approveClicked}
                className="w-[50%] h-[30px] text-[10px] rounded-[6px] flex items-center justify-center bg-blueColor text-white cursor-pointer"
              >
                APPROVE
              </div>
            </div>
          </div>
        </OutsideClickHandler>
      </div>
    )
  );
}

export default ApproveModal;
